/**
 * In-place Editor classes defined here.
 */
/** @hidden */
export var ROOT = 'e-inplaceeditor';
/** @hidden */
export var ROOT_TIP = 'e-inplaceeditor-tip';
/** @hidden */
export var VALUE_WRAPPER = 'e-editable-value-wrapper';
/** @hidden */
export var VALUE = 'e-editable-value';
/** @hidden */
export var OVERLAY_ICON = 'e-editable-overlay-icon';
/** @hidden */
export var TIP_TITLE = 'e-editable-tip-title';
/** @hidden */
export var TITLE = 'e-editable-title';
/** @hidden */
export var INLINE = 'e-editable-inline';
/** @hidden */
export var POPUP = 'e-editable-popup';
/** @hidden */
export var WRAPPER = 'e-editable-wrapper';
/** @hidden */
export var LOADING = 'e-editable-loading';
/** @hidden */
export var FORM = 'e-editable-form';
/** @hidden */
export var CTRL_GROUP = 'e-component-group';
/** @hidden */
export var INPUT = 'e-editable-component';
/** @hidden */
export var BUTTONS = 'e-editable-action-buttons';
/** @hidden */
export var EDITABLE_ERROR = 'e-editable-error';
/** @hidden */
export var ELEMENTS = 'e-editable-elements';
/** @hidden */
export var OPEN = 'e-editable-open';
/** @hidden */
export var BTN_SAVE = 'e-btn-save';
/** @hidden */
export var BTN_CANCEL = 'e-btn-cancel';
/** @hidden */
export var RTE_SPIN_WRAP = 'e-rte-spin-wrap';
/** @hidden */
export var CTRL_OVERLAY = 'e-control-overlay';
/** @hidden */
export var DISABLE = 'e-disable';
/** @hidden */
export var ICONS = 'e-icons';
/** @hidden */
export var PRIMARY = 'e-primary';
/** @hidden */
export var SHOW = 'e-show';
/** @hidden */
export var HIDE = 'e-hide';
/** @hidden */
export var RTL = 'e-rtl';
/** @hidden */
export var ERROR = 'e-error';
/** @hidden */
export var LOAD = 'e-loading';
